import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import ClientActivityCardContent from "./ClientActivityCardContent";

interface Props {
  activity: server.dto.ClientActivity
}

const ClientActivityRowCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <ClientActivityCardContent activity={activity} />
  </ActivityCard>;
};

export default ClientActivityRowCard;